// extracted by mini-css-extract-plugin
export var container = "_vs-0";
export var table = "_vs-2";
export var tableWrapper = "_vs-1";